export const packageList = [
	{
		label: '白银套餐',
		value: 1,
		desc: 'SILVER',
	},
	{
		label: '黄金套餐',
		value: 2,
		desc: 'GOLD',
	},
	{
		label: '白金套餐',
		value: 3,
		desc: 'PLATINUM',
	},
	{
		label: '钻石套餐',
		value: 4,
		desc: 'DIAMOND',
	},
	{
		label: '全球赢标准版',
		value: 5,
		desc: 'STANDARD',
	},
	{
		label: '全球赢商务版',
		value: 6,
		desc: 'BUSINESS',
	},
	{
		label: '全球赢豪华版',
		value: 7,
		desc: 'LUXURY',
	},
	{
		label: '全球赢尊享版',
		value: 8,
		desc: 'ENJOY',
	},
];
// /**
//  * 国际标准版
//  */
// INTERNATIONAL_STANDARD_VERSION("547827902524162048", "国际标准版"),
//     /**
//      * 国际商务版
//      */
//     INTERNATIONAL_BUSINESS_EDITION("547828055716921344", "国际商务版"),
//     /**
//      * 国际豪华版
//      */
//     INTERNATIONAL_DELUXE_EDITION("547828460215599104", "国际豪华版"),
//     /**
//      * 国际尊享版
//      */
//     INTERNATIONAL_VIP_EDITION("548079884430213120", "国际尊享版");
export const terminalList = [
	{
		label: 'PC站',
		value: 1,
	},
	{
		label: 'PC站+移动端',
		value: 2,
	},
	{
		label: 'PC站+移动端+微网站',
		value: 3,
	},
];
export const domainType = [
	{
		label: '甲方自有',
		value: 1,
	},
	{
		label: '乙方提供',
		value: 2,
	},
];
export const serviceLocate = [
	{
		label: '中国内陆',
		value: 1,
	},
	{
		label: '中国香港',
		value: 2,
	},
	{
		label: '美国',
		value: 3,
	},
];
export const lang = [
	{
		label: '汉语',
		value: 131003,
	},
	{
		label: '英语',
		value: 131004,
	},
	{
		label: '俄语',
		value: 131005,
	},
	{
		label: '韩语',
		value: 131006,
	},
	{
		label: '法语',
		value: 131007,
	},
	{
		label: '德语',
		value: 131008,
	},
	{
		label: '日语',
		value: 131009,
	},
	{
		label: '西班牙语',
		value: 131010,
	},
	{
		label: '意大利语',
		value: 131011,
	},
	{
		label: '葡萄牙语',
		value: 131012,
	},
	{
		label: '阿拉伯语',
		value: 131013,
	},
	{
		label: '越南语',
		value: 131014,
	},
];
export const taskStatus = [
	{
		label: '待开始',
		value: 1,
		class: 'info',
		btnInfo: '开始进行',
		nextStatus: 2,
	},
	{
		label: '进行中',
		value: 2,
		class: 'blue',
		btnInfo: '解决任务',
		nextStatus: 3,
	},
	{
		label: '已完成',
		value: 3,
		class: 'success',
		btnInfo: '重新打开',
		nextStatus: 1,
	},
];
export const isTransfer = [
	{
		label: '转移',
		value: 1,
	},
	{
		label: '无需转移',
		value: 2,
	},
];
export const serviceList = [
	{
		label: '系统',
		value: '0',
	},
	{
		label: '网建建设',
		value: '1',
	},
	{
		label: '社媒建设',
		value: '2',
	},
	{
		label: '谷歌推广',
		value: '3',
	},
	{
		label: '视频拍摄',
		value: '4',
	},
	{
		label: 'SEO',
		value: '5',
	},
	{
		label: '社媒运营',
		value: '6',
	},
	{
		label: '社媒推广',
		value: '7',
	},
	{
		label: '智能网站访客识别',
		value: '10',
	},
	{
		label: 'WhatsApp服务',
		value: '21',
	},
	{
		label: 'Yandex推广',
		value: '22',
	},
	{
		label: 'LinkedIn推广',
		value: '23',
	},
];

export const step = [
	{
		label: '主任务',
		value: '0',
	},
	{
		label: '子任务',
		value: '1',
	},
];

export const siteType = [
	{
		label: '新增',
		value: 1,
	},
	{
		label: '续费',
		value: 2,
	},
	{
		label: '老网站升级',
		value: 3,
	},
];
export const statusList = [
	{
		value: 1,
		label: '未授权',
		className: 'death',
	},
	{
		value: 2,
		label: '选择主页',
		className: 'warning',
	},
	{
		value: 3,
		label: '已授权',
		className: 'common',
	},
	{
		value: 4,
		label: '授权过期',
		className: 'death',
	},
	{
		status: 5,
		desc: '已封',
		className: 'danger',
	},
];
export const authStatus = [
	{
		label: '未授权',
		value: 1,
		iconClass: 'death',
	},
	{
		label: '已授权',
		value: 2,
		iconClass: 'common',
	},
	{
		label: '已封',
		value: 3,
		iconClass: 'death',
	},
];
export const genreSatus = [
	{
		label: '内部',
		value: 1,
	},
	{
		label: '外部',
		value: 2,
	},
];
export const accountStatus = [
	{
		label: '正常',
		value: 0,
	},
	{
		label: '已封',
		value: 1,
	},
];
export const tweetsStatus = [
	{
		label: '已推',
		value: 1,
		iconClass: 'success',
	},
	{
		label: '待推',
		value: 2,
		iconClass: 'danger',
	},
	{
		label: '失败',
		value: 3,
		iconClass: 'death',
	},
];
export const mediaPlatForm = [
	{
		label: 'LinkedIn',
		value: '25',
		iconClass: 'icon-linkedin',
	},
	{
		label: 'FaceBook',
		value: '26',
		iconClass: 'icon-facebook',
	},
	{
		label: 'Twitter',
		value: '27',
		iconClass: 'icon-TwitterIcon',
	},
	{
		label: 'TikTok',
		value: '29',
		iconClass: 'icon-tikTok',
	},
];
export const cacheTypes = {
	//从服务器端获取数据
	newData: 1,
	//从缓存中获取数据
	formCache: 2,
	//从服务器端获取数据并且覆盖当前缓存中的数据
	refreshCache: 3,
};
export const requestStatus = {
	requesting: 1,
	finish: 2,
	error: 3,
};

export const onLineStatus = [
	{
		label: '未上线',
		value: 0,
	},
	{
		label: '已上线',
		value: 1,
	},
	{
		label: '已下线',
		value: 2,
	},
];
export const roleList = [
	{
		name: '默认管理员',
		id: 1,
		disabled: true,
	},
	{
		name: '管理员',
		id: 2,
	},
	{
		name: '员工',
		id: 3,
	},
];

export const dateType = [
	{
		label: '过去7天',
		value: 0,
	},
	{
		label: '上周',
		value: 1,
	},
	{
		label: '过去6周',
		value: 2,
	},
	{
		label: '过去6个月',
		value: 3,
	},
];
export const gaDateType = [
	{
		label: '昨天',
		value: 1,
	},
	{
		label: '上周',
		value: 2,
	},
	{
		label: '过去七日',
		value: 3,
	},
	{
		label: '过去三十天',
		value: 4,
	},
];
export const websiteType = [
	{
		label: '全部',
	},
	{
		label: '电脑',
		value: 0,
	},
	{
		label: '手机',
		value: 1,
	},
	{
		label: '邮件',
		value: 2,
	},
	{
		label: 'Messenger',
		value: 5,
	},
	{
		label: 'Facebook表单询盘',
		value: 7,
	},
];

//工单处理状态

export const handleType = [
	{
		label: '处理中',
		value: 0,
	},
	{
		label: '无法解决',
		value: 1,
	},
	{
		label: '已解决',
		value: 2,
	},
	{
		label: '已关闭',
		value: 3,
	},
	{
		label: '已作废',
		value: 4,
	},
];

// 工单类型

export const workOrderType = [
	{
		label: '网建',
		value: 0,
	},
	{
		label: 'Google',
		value: 4,
	},
	{
		label: '社媒',
		value: 2,
	},
	{
		label: '视频',
		value: 3,
	},
	{
		label: 'Saas系统',
		value: 5,
	},
];

export const workOrderStatus = [
	{
		label: '受理中',
		value: 0,
	},
	{
		label: '无法受理',
		value: 1,
	},
	{
		label: '已受理',
		value: 2,
	},
	{
		label: '已关闭',
		value: 3,
	},
	{
		label: '作废',
		value: 4,
	},
];

// 问题类型
export const webProblemType = [
	{
		label: '网站修改',
		value: 0,
	},
	{
		label: '网站证书安装',
		value: 1,
	},
	{
		label: '网站代码安装',
		value: 2,
	},
	{
		label: '域名转出',
		value: 3,
	},
	{
		label: '域名购买',
		value: 19,
	},
	{
		label: '域名托管',
		value: 20,
	},
	{
		label: '域名续费',
		value: 21,
	},
	{
		label: '其他',
		value: 5,
	},
];

export const googleProblemType = [
	{
		label: '获取谷歌报告',
		value: 11,
	},
	{
		label: '账户情况了解',
		value: 12,
	},
	{
		label: '其他',
		value: 13,
	},
];

export const socialmediaProblemType = [
	{
		label: '更换社媒平台',
		value: 6,
	},
	{
		label: '注册社媒账号',
		value: 7,
	},
	{
		label: '社媒平台装修',
		value: 8,
	},
	{
		label: '申请自行维护社媒平台',
		value: 9,
	},
	{
		label: '其他',
		value: 10,
	},
];

export const videoProblemType = [
	{
		label: '视频修改',
		value: 14,
	},
	{
		label: '剧本修改',
		value: 15,
	},
	{
		label: '其他',
		value: 16,
	},
];

export const SaaSProblemType = [
	{
		label: '系统演示',
		value: 22,
	},
	{
		label: '申请邮箱',
		value: 23,
	},
	{
		label: '注销邮箱',
		value: 24,
	},
	{
		label: '账号问题',
		value: 18,
	},
];
// seo文章状态
export const articleStatus = [
	{
		label: '全部',
	},
	{
		label: '已用',
		value: 1,
	},
	{
		label: '未用',
		value: 0,
	},
];

// 中文映射
export const nameMap = {
	'Singapore Rep.': '新加坡',
	'Dominican Rep.': '多米尼加',
	Palestine: '巴勒斯坦',
	Bahamas: '巴哈马',
	'Timor-Leste': '东帝汶',
	Afghanistan: '阿富汗',
	'Guinea-Bissau': '几内亚比绍',
	"Côte d'Ivoire": '科特迪瓦',
	'Siachen Glacier': '锡亚琴冰川',
	'Br. Indian Ocean Ter.': '英属印度洋领土',
	Angola: '安哥拉',
	Albania: '阿尔巴尼亚',
	'United Arab Emirates': '阿联酋',
	Argentina: '阿根廷',
	Armenia: '亚美尼亚',
	'French Southern and Antarctic Lands': '法属南半球和南极领地',
	Australia: '澳大利亚',
	Austria: '奥地利',
	Azerbaijan: '阿塞拜疆',
	Burundi: '布隆迪',
	Belgium: '比利时',
	Benin: '贝宁',
	'Burkina Faso': '布基纳法索',
	Bangladesh: '孟加拉国',
	Bulgaria: '保加利亚',
	'The Bahamas': '巴哈马',
	'Bosnia and Herz.': '波斯尼亚和黑塞哥维那',
	Belarus: '白俄罗斯',
	Belize: '伯利兹',
	Bermuda: '百慕大',
	Bolivia: '玻利维亚',
	Brazil: '巴西',
	Brunei: '文莱',
	Bhutan: '不丹',
	Botswana: '博茨瓦纳',
	'Central African Rep.': '中非',
	Canada: '加拿大',
	Switzerland: '瑞士',
	Chile: '智利',
	China: '中国',
	'Ivory Coast': '象牙海岸',
	Cameroon: '喀麦隆',
	'Dem. Rep. Congo': '刚果民主共和国',
	Congo: '刚果',
	Colombia: '哥伦比亚',
	'Costa Rica': '哥斯达黎加',
	Cuba: '古巴',
	'N. Cyprus': '北塞浦路斯',
	Cyprus: '塞浦路斯',
	'Czech Rep.': '捷克',
	Germany: '德国',
	Djibouti: '吉布提',
	Denmark: '丹麦',
	Algeria: '阿尔及利亚',
	Ecuador: '厄瓜多尔',
	Egypt: '埃及',
	Eritrea: '厄立特里亚',
	Spain: '西班牙',
	Estonia: '爱沙尼亚',
	Ethiopia: '埃塞俄比亚',
	Finland: '芬兰',
	Fiji: '斐',
	'Falkland Islands': '福克兰群岛',
	France: '法国',
	Gabon: '加蓬',
	'United Kingdom': '英国',
	Georgia: '格鲁吉亚',
	Ghana: '加纳',
	Guinea: '几内亚',
	Gambia: '冈比亚',
	'Guinea Bissau': '几内亚比绍',
	'Eq. Guinea': '赤道几内亚',
	Greece: '希腊',
	Greenland: '格陵兰',
	Guatemala: '危地马拉',
	'French Guiana': '法属圭亚那',
	Guyana: '圭亚那',
	Honduras: '洪都拉斯',
	Croatia: '克罗地亚',
	Haiti: '海地',
	Hungary: '匈牙利',
	Indonesia: '印度尼西亚',
	India: '印度',
	Ireland: '爱尔兰',
	Iran: '伊朗',
	Iraq: '伊拉克',
	Iceland: '冰岛',
	Israel: '以色列',
	Italy: '意大利',
	Jamaica: '牙买加',
	Jordan: '约旦',
	Japan: '日本',
	Kazakhstan: '哈萨克斯坦',
	Kenya: '肯尼亚',
	Kyrgyzstan: '吉尔吉斯斯坦',
	Cambodia: '柬埔寨',
	Korea: '韩国',
	Kosovo: '科索沃',
	Kuwait: '科威特',
	'Lao PDR': '老挝',
	Lebanon: '黎巴嫩',
	Liberia: '利比里亚',
	Libya: '利比亚',
	'Sri Lanka': '斯里兰卡',
	Lesotho: '莱索托',
	Lithuania: '立陶宛',
	Luxembourg: '卢森堡',
	Latvia: '拉脱维亚',
	Morocco: '摩洛哥',
	Moldova: '摩尔多瓦',
	Madagascar: '马达加斯加',
	Mexico: '墨西哥',
	Macedonia: '马其顿',
	Mali: '马里',
	Myanmar: '缅甸',
	Montenegro: '黑山',
	Mongolia: '蒙古',
	Mozambique: '莫桑比克',
	Mauritania: '毛里塔尼亚',
	Malawi: '马拉维',
	Malaysia: '马来西亚',
	Namibia: '纳米比亚',
	'New Caledonia': '新喀里多尼亚',
	Niger: '尼日尔',
	Nigeria: '尼日利亚',
	Nicaragua: '尼加拉瓜',
	Netherlands: '荷兰',
	Norway: '挪威',
	Nepal: '尼泊尔',
	'New Zealand': '新西兰',
	Oman: '阿曼',
	Pakistan: '巴基斯坦',
	Panama: '巴拿马',
	Peru: '秘鲁',
	Philippines: '菲律宾',
	'Papua New Guinea': '巴布亚新几内亚',
	Poland: '波兰',
	'Puerto Rico': '波多黎各',
	'Dem. Rep. Korea': '朝鲜',
	Portugal: '葡萄牙',
	Paraguay: '巴拉圭',
	Qatar: '卡塔尔',
	Romania: '罗马尼亚',
	Russia: '俄罗斯',
	Rwanda: '卢旺达',
	'W. Sahara': '西撒哈拉',
	'Saudi Arabia': '沙特阿拉伯',
	Sudan: '苏丹',
	'S. Sudan': '南苏丹',
	Senegal: '塞内加尔',
	'Solomon Is.': '所罗门群岛',
	'Sierra Leone': '塞拉利昂',
	'El Salvador': '萨尔瓦多',
	Somaliland: '索马里兰',
	Somalia: '索马里',
	Serbia: '塞尔维亚',
	Suriname: '苏里南',
	Slovakia: '斯洛伐克',
	Slovenia: '斯洛文尼亚',
	Sweden: '瑞典',
	Swaziland: '斯威士兰',
	Syria: '叙利亚',
	Chad: '乍得',
	Togo: '多哥',
	Thailand: '泰国',
	Tajikistan: '塔吉克斯坦',
	Turkmenistan: '土库曼斯坦',
	'East Timor': '东帝汶',
	'Trinidad and Tobago': '特里尼达和多巴哥',
	Tunisia: '突尼斯',
	Turkey: '土耳其',
	Tanzania: '坦桑尼亚',
	Uganda: '乌干达',
	Ukraine: '乌克兰',
	Uruguay: '乌拉圭',
	'United States': '美国',
	Uzbekistan: '乌兹别克斯坦',
	Venezuela: '委内瑞拉',
	Vietnam: '越南',
	Vanuatu: '瓦努阿图',
	'West Bank': '西岸',
	Yemen: '也门',
	'South Africa': '南非',
	Zambia: '赞比亚',
	Zimbabwe: '津巴布韦',
};
export const inquirytime = [
	{
		label: '过去7天',
		value: 0,
		name: 'DAYS_7',
	},
	{
		label: '上周',
		value: 1,
		name: 'WEEK',
	},
	{
		label: '过去6周',
		value: 2,
		name: 'WEEK_6',
	},
	{
		label: '过去6个月',
		value: 3,
		name: 'MONTH_6',
	},
];

export const charttime = [
	{
		label: '昨天',
		value: 0,
		name: 'DAY',
	},
	{
		label: '上周',
		value: 1,
		name: 'WEEK',
	},
	{
		label: '过去7天',
		value: 2,
		name: 'DAYS_7',
	},
	{
		label: '过去30天',
		value: 3,
		name: 'DAYS_30',
	},
];

export const inquirytype = [
	{
		label: '表单询盘',
		value: 90,
	},
	{
		label: '邮件询盘',
		value: 2,
	},
	{
		label: '社媒线索',
		value: 3,
	},
	{
		label: 'Messenger 询盘',
		value: 5,
	},
	// {
	//   label: '手动录入询盘',
	//   value: 6,
	// },
	{
		label: 'Facebook表单询盘',
		value: 7,
	},
];
export const socialDate = [
	{
		label: '昨天',
		name: 'DAY',
		value: 0,
	},
	{
		label: '过去7天',
		name: 'DAYS_7',
		value: 1,
	},
	{
		label: '过去28天',
		name: 'DAYS_28',
		value: 2,
	},
];
export const whether = [
	{
		label: '已跟进',
		value: 1,
	},
	{
		label: '未跟进',
		value: 0,
	},
];

export const googleOption = [
	{
		label: '展示次数',
		value: 'IMPRESSIONS',
	},
	{
		label: '点击次数',
		value: 'CLICKS',
	},
	{
		label: '消耗',
		value: 'COST',
	},
];
export const googleOptions = [
	{
		label: '点击率',
		value: 'clickRate',
	},
	{
		label: '点击均价',
		value: 'clickOnAverage',
	},
];
export const googleOptionPie = [
	{
		label: '展示占比',
		value: 'IMPRESSIONS',
	},
	{
		label: '点击占比',
		value: 'CLICKS',
	},
	{
		label: '消耗占比',
		value: 'COST',
	},
];

export const googleTimeSwitch = [
	{
		label: '日报',
		value: 'DAILY',
	},
	{
		label: '周报',
		value: 'WEEKLY',
	},
	{
		label: '月报',
		value: 'MONTHLY',
	},
];
export const timeSwitch = [
	{
		label: '日',
		value: 'DAILY',
	},
	{
		label: '周',
		value: 'WEEKLY',
	},
	{
		label: '月',
		value: 'MONTHLY',
	},
];

export const invitationStart = [
	{
		label: '已发布',
		value: 1,
	},
	{
		label: '待发布',
		value: 2,
	},
	{
		label: '发布失败',
		value: 3,
	},
];

export const messageStatus = [
	{
		label: '未读',
		value: 0,
	},
	{
		label: '已读',
		value: 1,
	},
];

export const messageType = [
	{
		label: '点赞',
		value: 1,
	},
	{
		label: '评论',
		value: 2,
	},
	{
		label: '留言',
		value: 4,
	},
];
export const userType = [
	{
		label: '内部运营',
		value: 1,
	},
	{
		label: '客户运营',
		value: 2,
	},
];

export const triggerCondition = [
	{
		label: '任务状态',
		value: 1,
	},
	{
		label: '负责人',
		value: 2,
	},
	{
		label: '处理人',
		value: 3,
	},
	{
		label: '时间',
		value: 4,
	},
];

export const autoTriggerResult = [
	{
		label: '状态变更',
		value: 4,
	},
	{
		label: '变为进行中',
		value: 2,
	},
	{
		label: '变为已完成',
		value: 3,
	},
	{
		label: '变为待开始',
		value: 1,
	},
];

export const triggerMessage = [
	{
		label: '客户账号邮箱',
		value: '1',
	},
	{
		label: '网站通知邮箱',
		value: '2',
	},
];

export const triggerCopy = [
	{
		label: '负责人',
		value: '1',
	},
	{
		label: '处理人',
		value: '2',
	},
];

export const inquirysource = [
	{
		label: '表单询盘',
		value: '1',
	},
	{
		label: '邮件询盘',
		value: '2',
	},
	{
		label: 'Messenger询盘',
		value: '5',
	},
	{
		label: 'Facebook表单询盘',
		value: '7',
	},
	{
		label: 'WhatsApp询盘',
		value: '8',
	},
];

export const systemFilterType = [
	{
		label: '邮件过滤',
		value: 1,
	},
	{
		label: '内容过滤',
		value: 2,
	},
	{
		label: '关键词过滤',
		value: 3,
	},
];

export const reviewType = [
	{
		label: '复查通过',
		value: 1,
	},
	{
		label: '复查不通过',
		value: 2,
	},
];

export const sitePlatform = [
	{
		label: '建站供应商',
		value: 1,
	},
	{
		label: '外贸云建站',
		value: 2,
	},
	{
		label: '客户自有网站',
		value: 3,
	},
];
export const garbageEnquiries = [
	{
		label: '全部询盘',
		value: '',
	},
	{
		label: '过滤垃圾询盘',
		value: 0,
	},
	{
		label: '仅看垃圾询盘',
		value: 1,
	},
];
export const ProductStatus = [
	{
		label: '全部状态',
		value: '',
	},
	{
		label: '未上架',
		value: '0',
	},
	{
		label: '已上架',
		value: '1',
	},
];
export const rootDirectory = [
	{
		label: '根目录',
		value: '0',
	},
];
export const companyEmail = [
	{
		label: '新版邮箱列表',
		value: 4,
	},
	{
		label: '新版企业邮箱',
		value: 1,
		disabled: true,
	},
	{
		label: '旧版企业邮箱',
		value: 2,
	},
	{
		label: '不使用',
		value: 3,
	},
];

export const customerStatus = [
	{
		label: '活跃',
		value: 1,
	},
	{
		label: '暂停',
		value: 2,
	},
	{
		label: '死亡',
		value: 3,
	},
];

export const warningType = [
	{
		label: '网站',
		value: 1,
	},
	{
		label: 'KPI',
		value: 2,
	},
	{
		label: '账户',
		value: 3,
	},
	{
		label: '广告系列',
		value: 4,
	},
	{
		label: '广告组',
		value: 5,
	},
	{
		label: '广告',
		value: 6,
	},
	{
		label: '关键字',
		value: 7,
	},
	{
		label: '附加信息',
		value: 8,
	},
];

export const warningPriority = [
	{
		label: '优先级一',
		value: 1,
	},
	{
		label: '优先级二',
		value: 2,
	},
	{
		label: '优先级三',
		value: 3,
	},
];

export const warningStatus = [
	{
		label: '已开启',
		value: 1,
	},
	{
		label: '未开启',
		value: 0,
	},
];

export const serviceStaff = [
	{
		label: '网站服务人员',
		value: 1,
	},
	{
		label: '社媒服务人员',
		value: 2,
	},
	{
		label: 'Google推广服务人员',
		value: 3,
	},
	{
		label: '视频拍摄服务人员',
		value: 4,
	},
	{
		label: 'FB推广服务人员',
		value: 7,
	},
];

export const reportType = [
	{
		label: '周报',
		value: 1,
	},
	{
		label: '月报',
		value: 2,
	},
];

export const taskflowRichtext = [
	{
		value: '##customerName##',
		label: '客户名称',
	},
	{
		value: '##packageName##',
		label: '套餐名称',
	},
	{
		value: '##inquiryMail##',
		label: '询盘邮箱',
	},
	{
		value: '##accountMobileAndName##',
		label: '客户账号：手机号+名称',
	},
	{
		value: '##pcDomain##',
		label: '主站-PC域名',
	},
	{
		value: '##mobileDomain##',
		label: '主站-移动端域名',
	},
	{
		value: '##onlineTime##',
		label: '主站-网站上线日期',
	},
	{
		value: '##pcWebsitePreviewUrl##',
		label: '主站-PC预览地址',
	},
	{
		value: '##mobileWebsitePreviewUrl##',
		label: '主站-移动端预览地址',
	},
	{
		value: '##subPcDomain##',
		label: '小语种-PC域名',
	},
	{
		value: '##subMobileDomain##',
		label: '小语种-移动端域名',
	},
	{
		value: '##subPcWebsitePreviewUrl##',
		label: '小语种-PC预览地址',
	},
	{
		value: '##subMobileWebsitePreviewUrl##',
		label: '小语种-移动端预览地址',
	},
	{
		value: '##websiteLoginUrl##',
		label: '网站后台登录地址',
	},
	{
		value: '##customerEmail##',
		label: '后台登录账号：客户邮箱',
	},
	{
		value: '##customerPassword##',
		label: '后台登录密码',
	},
];

export const featureType = [
	{
		label: '系统',
		value: 0,
	},
	{
		label: '网站建设',
		value: 1,
	},
	{
		label: '社媒建设',
		value: 2,
	},
	{
		label: '谷歌推广',
		value: 3,
	},
	{
		label: '视频拍摄',
		value: 4,
	},
	{
		label: 'SEO',
		value: 5,
	},
	{
		label: '社媒运营',
		value: 6,
	},
	{
		label: '社媒推广',
		value: 7,
	},
	{
		label: '服务费',
		value: 8,
	},
	{
		label: '税费',
		value: 9,
	},
	{
		label: '智能网站访客识别',
		value: 10,
	},
	{
		label: '邮件营销',
		value: '11',
	},
	{
		label: '系统账号',
		value: 12,
	},
	{
		label: '网站建设小语种',
		value: 13,
	},
	{
		label: '云盘',
		value: 14,
	},
];

export const featurePermissions = [
	{
		label: '系统访问',
		value: 1,
	},
	{
		label: '网站编辑及数据',
		value: 2,
	},
	{
		label: '社媒查看',
		value: 3,
	},
	{
		label: '社媒发送',
		value: 4,
	},
	{
		label: '社媒推广报告',
		value: 5,
	},
	{
		label: '谷歌推广报告',
		value: 6,
	},
	{
		label: '智能网站访客识别',
		value: 7,
	},
	{
		label: '邮件营销',
		value: 8,
	},
	{
		label: '云盘',
		value: 9,
	},
	{
		label: 'SEO',
		value: 10,
	},
];

export const featureUnit = [
	{
		label: '个',
		value: 1,
	},
	{
		label: '日',
		value: 2,
	},
	{
		label: '周',
		value: 3,
	},
	{
		label: '月',
		value: 4,
	},
	{
		label: '年',
		value: 5,
	},
	{
		label: '个/月',
		value: 6,
	},
];

export const termsType = [
	{
		label: '搜索词',
		value: 0,
	},
	{
		label: '自定义',
		value: 1,
	},
];

export const searchTermsType = [
	{
		label: '广泛匹配',
		value: 1,
	},
	{
		label: '完全匹配',
		value: 2,
	},
	{
		label: '词组匹配',
		value: 5,
	},
	{
		label: '精确匹配（紧密变体）',
		value: 3,
	},
	{
		label: '词组匹配（紧密变体）',
		value: 4,
	},
	{
		label: 'Ai Max',
		value: 8,
	},
	{
		label: 'Performance Max',
		value: 9,
	},
];

export const searchTermsStatus = [
	{
		label: '已添加',
		value: 1,
	},
	{
		label: '已添加/已排除',
		value: 2,
	},
	{
		label: '已排除',
		value: 3,
	},
	{
		label: '未知',
		value: 4,
	},
	{
		label: '已忽略',
		value: 5,
	},
];

export const searchTermsMark = [
	{
		label: '添加',
		value: 1,
	},
	{
		label: '排除',
		value: 3,
	},
];
export const fbChartsCount = [
	{
		label: '消耗',
		value: 'COST',
		bind: 'exchangeRateCost',
	},
	{
		label: '展示次数',
		value: 'IMPRESSIONS',
		bind: 'impressions',
	},
	{
		label: '成效',
		value: 'EFFECT',
		bind: 'effect',
	},
	{
		label: '覆盖人数',
		value: 'COVERS',
		bind: 'covers',
	},
];

export const fbChartsRatio = [
	{
		label: '成效获得率',
		value: 'effectiveRate',
	},
	{
		label: '成效均价',
		value: 'effectOnAverage',
	},
];
export const audienceReportCount = [
	{
		label: '消耗',
		value: 'exchangeRateCost',
	},
	{
		label: '展示次数',
		value: 'impressions',
	},
	{
		label: '覆盖人数',
		value: 'covers',
	},
];
export const audienceReportRatio = [
	{
		label: '消耗占比',
		value: 'exchangeRateCost',
	},
	{
		label: '展示占比',
		value: 'impressions',
	},
	{
		label: '覆盖占比',
		value: 'covers',
	},
];
export const fbChartsRatioPie = [
	{
		label: '展示占比',
		value: 'IMPRESSIONS',
		sub: '展示次数',
	},
	{
		label: '成效占比',
		value: 'EFFECT',
		sub: '成效',
	},
	{
		label: '消耗占比',
		value: 'COST',
		sub: '消耗',
	},
];

export const passMap = [
	{
		name: '有效询盘',
		code: 1,
	},
	{
		name: '疑似询盘',
		code: 2,
	},
	{
		name: '对客户有利的营销',
		code: 3,
	},
	{
		name: '其他应提供客户的信息',
		code: 4,
	},
	{
		name: '测试询盘',
		code: 5,
	},
];

export const statusMap = [
	{
		label: '全部',
		value: -1,
	},
	{
		label: '待审核',
		value: 0,
		status: 'warning',
	},
	{
		label: '系统通过',
		value: 1,
		status: 'info',
	},
	{
		label: '审核不通过',
		value: 2,
		status: 'danger',
	},
	{
		label: '审核通过',
		value: 3,
		status: 'primary',
	},
	{
		label: '系统过滤',
		value: 4,
		status: 'danger',
	},
];

export const evaluationType = [
	{
		label: '订单评价',
		value: 0,
	},
	{
		label: '服务评价',
		value: 1,
	},
	{
		label: '月度评价',
		value: 2,
	},
];

export const evaluationStatus = [
	{
		label: '未评价',
		value: 0,
	},
	{
		label: '已评价',
		value: 1,
	},
	{
		label: '已失效',
		value: 2,
	},
];

export const effectiveStatu = [
	{
		label: '正在生效',
		value: 1,
	},
	{
		label: '即将生效',
		value: 2,
	},
];

export const functionStatus = [
	{
		label: '正在生效',
		value: 1,
	},
	{
		label: '即将生效',
		value: 2,
	},
	{
		label: '已关闭',
		value: 3,
	},
];

export const billingPeriodType = [
	{
		label: '合同签订',
		value: 1,
	},
	{
		label: '网站上线',
		value: 2,
	},
	{
		label: '消耗',
		value: 3,
	},
	{
		label: '功能',
		value: 4,
	},
];

export const systemInfo = {
	1: {
		name: '智能营销',
	},
	2: {
		name: 'CRM客户管理系统',
	},
	3: {
		name: '外贸智能云建站',
	},
	4: {
		name: 'Google广告管理系统',
	},
	5: {
		name: 'SNS跨平台云社交系统',
	},
	6: {
		name: 'Facebook广告管理系统',
	},
	8: {
		name: '企业中心',
	},
};

export let dataFromType = [
	{
		value: true,
		label: '开启',
	},
	{
		value: false,
		label: '关闭',
	},
];

export const seoCountryList = [
	{
		label: '澳大利亚',
		value: 2036,
	},
	{
		label: '加拿大',
		value: 2124,
	},
	{
		label: '德国',
		value: 2276,
	},
	{
		label: '西班牙',
		value: 2724,
	},
	{
		label: '法国',
		value: 2250,
	},
	{
		label: '日本',
		value: 2392,
	},
	{
		label: '墨西哥',
		value: 2484,
	},
	{
		label: '美国',
		value: 2840,
	},
	{
		label: '英国',
		value: 2826,
	},
	{
		label: '印度',
		value: 2356,
	},
];

export const scanFrequencyList = [
	{
		label: '每周',
		value: 1,
	},
	{
		label: '每月',
		value: 2,
	},
	{
		label: '每季度',
		value: 3,
	},
];

export const scanSourceList = [
	{
		label: '仅来源GSC',
		value: 1,
	},
	{
		label: '仅来源于有消耗的关键词',
		value: 2,
	},
	{
		label: '优先有消耗的关键词,其次GSC词',
		value: 3,
	},
	{
		label: '优先GSC词,其次有消耗的关键词',
		value: 4,
	},
];

export const consumeCycleList = [
	{
		label: '近7天',
		value: 1,
	},
	{
		label: '近30天',
		value: 2,
	},
	{
		label: '近90天',
		value: 3,
	},
	{
		label: '近180天',
		value: 4,
	},
	{
		label: '近365天',
		value: 5,
	},
];
// 广告系列状态类型
export const adSeriesStatus = [
	{
		value: 'ENABLED',
		label: '已启用',
	},
	{
		value: 'PAUSED',
		label: '已暂停',
	},
	{
		value: 'REMOVED',
		label: '已移除',
	},
];

// 账户状态类型
export const accountsStatus = {
	ENABLED: '已启用',
	PAUSED: '已暂停',
	REMOVED: '已移除',
};

// 货币种类
export const currencies = [
	{ value: 127001, symbol: '¥', label: '人民币' }, // 人民币
	{ value: 127002, symbol: '$', label: '美元' }, // 美元
	{ value: 127003, symbol: 'HK$', label: '港元' }, // 港元
	{ value: 127004, symbol: '₽', label: '俄罗斯卢布' }, // 俄罗斯卢布
	{ value: 127005, symbol: 'S$', label: '新加坡元' }, // 新加坡元

	// { value: 'CNY', symbol: '¥', label: '人民币' }, // 人民币
	// { value: 'USD', symbol: '$', label: '美元' }, // 美元
	// { value: 'EUR', symbol: '€', label: '欧元' }, // 欧元
	// { value: 'GBP', symbol: '£', label: '英镑' }, // 英镑
	// { value: 'JPY', symbol: '¥', label: '日元' }, // 日元
	// { value: 'AUD', symbol: 'A$', label: '澳大利亚元' }, // 澳大利亚元
	// { value: 'CAD', symbol: 'C$', label: '加拿大元' }, // 加拿大元
	// { value: 'CHF', symbol: 'CHF', label: '瑞士法郎' }, // 瑞士法郎
	// { value: 'HKD', symbol: 'HK$', label: '港元' }, // 港元
	// { value: 'NZD', symbol: 'NZ$', label: '新西兰元' }, // 新西兰元
	// { value: 'SEK', symbol: 'kr', label: '瑞典克朗' }, // 瑞典克朗
	// { value: 'NOK', symbol: 'kr', label: '挪威克朗' }, // 挪威克朗
	// { value: 'DKK', symbol: 'kr', label: '丹麦克朗' }, // 丹麦克朗
	// { value: 'INR', symbol: '₹', label: '印度卢比' }, // 印度卢比
	// { value: 'RUB', symbol: '₽', label: '俄罗斯卢布' }, // 俄罗斯卢布
	// { value: 'ZAR', symbol: 'R', label: '南非兰特' }, // 南非兰特
	// { value: 'BRL', symbol: 'R$', label: '巴西雷亚尔' }, // 巴西雷亚尔
	// { value: 'MXN', symbol: 'Mex$', label: '墨西哥比索' }, // 墨西哥比索
	// { value: 'SGD', symbol: 'S$', label: '新加坡元' }, // 新加坡元
	// { value: 'KRW', symbol: '₩', label: '韩元' }, // 韩元
];

export const osOptions = [
	{
		label: 'Android',
		value: 'Android',
	},
	{
		label: 'iPad',
		value: 'iPad',
	},
	{
		label: 'iPhone',
		value: 'iPhone',
	},
	{
		label: 'Mac',
		value: 'Mac',
	},
	{
		label: 'Windows',
		value: 'Windows',
	},
];

export const secondReviewOptions = [
	{
		label: '未审核',
		value: 0,
	},
	{
		label: '已审核',
		value: 1,
	},
	{
		label: '客户审核',
		value: 2,
	},
	{
		label: '不需要审核',
		value: 3,
	},
];
